<template>
  <v-dialog
      v-model="$store.state.dialog.item_point"
      max-width="700"
      overlay-opacity="0.8"
      persistent
  >
    <v-card class="view">
      <v-container>
        <v-row>
          <v-col>
            <v-btn class="float-left" color="primary" fab outlined small
                   @click="onClickPrevious()">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-btn class="float-right" color="primary" fab outlined small
                   @click="onClickNext()">
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>

            <v-card class="ma-1 ml-4 float-left headline">รหัส: {{ current_product.code }}</v-card>

          </v-col>
        </v-row>


        <v-row>

          <v-col>
            ชื่อสินค้า: {{ current_product.nickname }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-right col-4">
            <v-img
                v-if="current_product && current_product.image_path"
                :lazy-src="'/'+current_product.image_path+'.64.jpg'"
                :src="'/'+current_product.image_path+'.236.jpg'"
                aspect-ratio="1"
                class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-row
                    align="center"
                    class="fill-height ma-0"
                    justify="center"
                >
                  <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
                </v-row>
              </template>
            </v-img>

            <div><span
                class="float-left">ชนิด </span>{{ current_product.type = 'F' ? 'สินค้าสำเร็จรูป' : 'สินค้าอื่นๆ' }}
            </div>

            <div><span
                class="float-left">กลุ่มสินค้า </span>{{
                current_product.type_code == 'TRAD_OFM' ? 'OFM' : current_product.group
              }}
            </div>
            <div><span class="float-left">สี</span>{{ current_product.color }}</div>
            <div><span class="float-left">ขนาด</span>{{ current_product.size }} ml</div>

          </v-col>

          <v-col style="border-left: solid 1px;">


            <div class="headline mt-2 mb-2">
              <div v-if="$store.state.carts.current.id">


                คลัง:
                {{
                  number_format(current_product['stock_MT'] *
                      current_product['unit_prim_rate'] - current_product['reserve_MT'], 0)
                }}
                <span class="unit">{{ $helper.parseUnit(current_product['unit_primitive']) }}</span>
              </div>
              <div v-else>

                <div class="mb-2">คลัง MT {{
                    number_format(current_product['stock_MT'] *
                        current_product['unit_prim_rate'] - current_product['reserve_MT'], 0)
                  }}
                  <span class="unit">{{ $helper.parseUnit(current_product['unit_primitive']) }}</span>
                </div>
                <div>คลัง PJ {{ number_format(current_product['stock_PJ'] * current_product['unit_prim_rate'], 0) }}
                  <span class="unit">{{ $helper.parseUnit(current_product['unit_primitive']) }}</span></div>

              </div>

            </div>

            <div class="title">
              <table style="width: 100%">


                <tr>
                  <td class="text-left">แต้ม/หน่วย</td>
                  <td class="text-right" colspan="2">
                    <v-icon x-small color="orange">mdi-star</v-icon>
                    <span
                      class="price_amount orange--text"
                      @click="openPointFinal(item)">{{
                      number_format(item.point_final || 0, 2, 2)
                    }}</span>

                  </td>
                </tr>


              </table>


            </div>

          </v-col>

        </v-row>


        <v-row>
          <v-col class="text-right display-1 pt-6">จำนวนสั่ง</v-col>
          <v-col>


            <table width="100%">
              <tr>
                <td>
                  <v-btn
                      :loading="item._save_state==='dirty'" class="primary" fab
                      tile
                      width="100%"
                      @click.stop="onClickDelta(item,-1)"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>

                </td>
                <td>
                  <v-card
                      class="display-1 text-center pa-2"
                      outlined
                      style="position: relative;padding: 0 16px 16px !important;"
                  >
                    {{ item.quantity }}
                    <span
                        style="font-size: 0.5em;position: absolute;bottom: -11px;right: 0;display: block;width: 100%;text-align: center;"> {{
                        $helper.parseUnit(item.unit)
                      }} </span>
                  </v-card>
                </td>
                <td>

                  <v-btn
                      :loading="item._save_state==='dirty'" class="primary" fab
                      tile
                      width="100%"
                      @click.stop="onClickDelta(item,1)"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </td>
              </tr>
            </table>


          </v-col>
          <v-col class="col-2 pt-4">

            <v-btn class="close-button float-right" color="primary" fab tile width="100%"
                   :loading="isLoading"
                   @click="onClickApply()">
              <v-icon>mdi-check-bold</v-icon>
            </v-btn>

          </v-col>

        </v-row>


      </v-container>


    </v-card>
  </v-dialog>
</template>
<style lang="scss" scoped>
.view {
  position: relative;
  /*background: #FF0000;*/
}

.price_amount {
  display: block;
  width: 140px;
  border: #636b6f solid 1px;
  float: right;
  padding-right: 8px;
}

.discount_percent {
  display: block;
  width: 80px;
  border: #636b6f solid 1px;
  float: right;
  padding-right: 4px;
}

.discount_amount {
  display: block;
  width: 100px;
  border: #636b6f solid 1px;
  float: right;
  padding-right: 8px;
}

.unit {
  /*font-size: 0.5em;*/
}

.percent {
  font-size: 0.7em;
}

.currency {
  display: block;
  width: 32px;
  float: right;
  font-size: 0.7em;
}


</style>

<script lang="ts">

import {Component, Vue} from 'vue-property-decorator'
import {Item} from '../models/Item'
import {Order} from '../models/Order'
import {Product} from '../models/Product'
import Helper from '../services/Helper.js'

@Component({
  components: {}
})
export default class ItemDialogPoint extends Vue {
  number_format = Helper.number_format
  order: Order = new Order()
  item: Item = new Item()

  get current_product(): Product | null {
    if (!this.item.product) return new Product()
    return this.item.product
  }

  mounted() {
    this.reloadItem()
  }

  async openPriceExVat(item: Item, price_in_vat) {
    const vat_percent = this.order.vat_percent ? this.order.vat_percent : 0
    this.$root.$emit('openCalculator', {
      number: price_in_vat, onApply: async (number) => {
        item.price_ex_vat = number
        item.price_in_vat = Math.round(number * (1.00 + vat_percent / 100) * 100) / 100.0
        this.reCalTotal(item)
      }
    })
  }

  async openPriceInVat(item: Item, price_in_vat) {
    const vat_percent = this.order.vat_percent ? this.order.vat_percent : 0
    this.$root.$emit('openCalculator', {
      number: price_in_vat, onApply: async (number) => {
        item.price_in_vat = number
        item.price_ex_vat = Math.round(number / (1.00 + vat_percent / 100) * 100) / 100.0
        this.reCalTotal(item)
      }
    })
  }

  async openPointFinal(item: Item) {
    this.$root.$emit('openCalculator', {
      number: item.point_final || 0, onApply: async (number) => {
        item.point_final = number
        this.reCalTotalPoint(item)
      }
    })
  }

  reCalTotalPoint(item: Item) {
    // For point orders, calculate total_point based on point_final and quantity
    item.total_point = (item.point_final || 0) * (item.quantity || 0)
  }


  async openDiscountInternalPercent(item: Item, discount_internal_percent) {
    this.$root.$emit('openCalculator', {
      number: discount_internal_percent, onApply: async (number) => {
        item.discount_internal_percent = number
        item.discount_internal_mode = '%'

        if (item.price_in_vat != null && item.quantity != null)
          item.discount_internal_amount = Math.round(number / 100 * (item.price_in_vat * item.quantity) * 100) / 100
        this.reCalTotal(item)
      }
    })
  }

  async openDiscountInternalAmount(item: Item, discount_internal_amount) {
    this.$root.$emit('openCalculator', {
      number: discount_internal_amount, onApply: async (number) => {
        item.discount_internal_amount = number
        item.discount_internal_mode = '$'

        if (item.price_in_vat != null && item.quantity != null)
          item.discount_internal_percent = Math.round(number * 100 / (item.price_in_vat * item.quantity) * 100) / 100
        this.reCalTotal(item)
      }
    })
  }

  async openDiscountExternalPercent(item: Item, discount_external_percent) {
    this.$root.$emit('openCalculator', {
      number: discount_external_percent, onApply: async (number) => {
        item.discount_external_percent = number
        item.discount_external_mode = '%'

        if (item.price_ex_vat != null && item.quantity != null)
          item.discount_external_amount = Math.round(number / 100 * (item.price_ex_vat * item.quantity) * 100) / 100
        this.reCalTotal(item)
      }
    })
  }

  async openDiscountExternalAmount(item: Item, discount_external_amount) {
    this.$root.$emit('openCalculator', {
      number: discount_external_amount, onApply: async (number) => {
        item.discount_external_amount = number
        item.discount_external_mode = '$'

        if (item.price_ex_vat != null && item.quantity != null) {
          item.discount_external_percent = Math.round(number * 100 / (item.price_ex_vat * item.quantity) * 100) / 100
        }
        this.reCalTotal(item)
      }
    })
  }


  reCalTotal(item: Item) {

    // item.price_ex_vat = item.price_in_vat / 1.07

    // if (item.discount_internal_percent !== null) {
    //   item.discount_internal_amount = item.price_ex_vat * item.discount_internal_percent / 100
    //   //price = price - item.discount_internal_amount
    // }
    // if (item.discount_external_percent !== null) {
    //   item.discount_external_amount = item.price_ex_vat * item.discount_external_percent / 100
    //   // item.price_final = price - item.discount_external_percent
    // }

    const vat_percent = this.order.vat_percent ? this.order.vat_percent : 0

    item.price_final = item.price_in_vat
    if (item.discount_internal_amount !== null && item.quantity !== null) {
      item.price_final -= item.discount_internal_amount / item.quantity
    }
    // item.price_final = Math.round(item.price_final / (1.00 + vat_percent / 100) * 100) / 100
    if (item.discount_external_amount !== null && item.quantity !== null) {
      item.price_final -= (item.discount_external_amount / item.quantity) * (1.00 + vat_percent / 100)
    }
    item.price_final = Math.round(item.price_final * 100) / 100

    let price_at_bill = item.price_in_vat
    if (item.discount_internal_amount !== null && item.quantity !== null) {
      price_at_bill -= item.discount_internal_amount / item.quantity
    }

    if (item.quantity !== null) {
      item.total_net = item.quantity * price_at_bill
      item.total_gross = Math.round(item.total_net / (1.00 + vat_percent / 100) * 100) / 100
    }
    console.log('recal Item', item)


  }

  AddFreeRecord(item: Item) {
    this.$store.dispatch('add_item_to_cart', {product: item.product, delta: 1, is_free: true})
    this.$store.commit('dialog_is_item_point', {toggle: false})
  }

  onClickDelta(item: Item, delta = 1) {
    let quantity = item.quantity
    if (quantity != null && item.discount_internal_amount != null) {
      let discount_internal_amount = item.discount_internal_amount
      let discount_internal_per_item = discount_internal_amount / quantity
      item.discount_internal_amount += discount_internal_per_item * delta

    }
    if (quantity != null && item.discount_external_amount != null) {
      let discount_external_amount = item.discount_external_amount
      let discount_external_per_item = discount_external_amount / quantity
      item.discount_external_amount += discount_external_per_item * delta
    }

    if (item.quantity == null) {
      item.quantity = delta
    } else {
      item.quantity += delta
    }

    this.reCalTotal(item)
  }

  isLoading = false

  async onClickApply() {
    this.isLoading = true
    const item: Item = this.$store.state.carts.current.items[this.$store.state.items.current_index]
    if (!item) {
      this.$store.commit('dialog_is_item_point', {toggle: false})
      this.isLoading = false
      return
    }
    try {
      if (!item.hasOwnProperty('dirty')) {
        Object.setPrototypeOf(item, Item.prototype)
      }
      item.dirty()
      await item.gracefulSave()

      await this.$store.dispatch('set_item', item)
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.isLoading = false
    this.$store.commit('dialog_is_item_point', {toggle: false})
  }

  onClickPrevious() {
    this.$store.commit('item_current', -1)
    this.reloadItem()
  }

  onClickNext() {
    this.$store.commit('item_current', 1)
    this.reloadItem()
  }

  reloadItem() {
    const cart: Order = this.$store.state.carts.current
    const item: Item = this.$store.state.carts.current.items[this.$store.state.items.current_index]
    if (!item) {
      this.$store.commit('dialog_is_item_point', {toggle: false})
      this.isLoading = false
      return
    }
    if (!item.discount_internal_percent)
      item.discount_internal_percent = 0
    if (!item.discount_internal_amount)
      item.discount_internal_amount = 0
    if (!item.discount_external_percent)
      item.discount_external_percent = 0
    if (!item.discount_external_amount)
      item.discount_external_amount = 0

    // console.log("item.price_last",item.price_last)
    if (!item.price_at_bill)
      item.price_at_bill = 0

    console.log('Loaded item', item)
    this.order = cart
    this.item = item
  }
};

</script>
